import {
  decodeFromURLParams,
  encodeToURLParams,
  UIFilterConverters,
  URLStateConverter,
} from './filter-state-to-url-params'
import { UIFilters } from './types'

type ExploreMapState = UIFilters & {
  lat?: number
  lng?: number
  zoom?: number
}

const ExploreMapStateConverters: {
  [TKey in keyof ExploreMapState]-?: URLStateConverter<ExploreMapState[TKey]>
} = {
  lat: {
    encode: (value) => value?.toString(),
    decode: (values) => paramToFloat(values?.[0]),
  },
  lng: {
    encode: (value) => value?.toString(),
    decode: (values) => paramToFloat(values?.[0]),
  },
  zoom: {
    encode: (value) => value?.toString(),
    decode: (values) => paramToInt(values?.[0]),
  },
  ...UIFilterConverters,
}

const paramToInt = (v?: string): number | undefined => {
  const parsed = v ? parseInt(v) : undefined
  return parsed === undefined || isNaN(parsed) ? undefined : parsed
}
const paramToFloat = (v?: string): number | undefined => {
  const parsed = v ? parseFloat(v) : undefined
  return parsed === undefined || isNaN(parsed) ? undefined : parsed
}

export const decodeExploreMapStateParams = (params: URLSearchParams): ExploreMapState => {
  return decodeFromURLParams(params, ExploreMapStateConverters)
}
export const encodeExploreMapState = (state: ExploreMapState, initialParams?: URLSearchParams): URLSearchParams => {
  return encodeToURLParams(state, ExploreMapStateConverters, initialParams)
}
